import styled from 'styled-components';

import {
  type TextareaProps as AUITextAreaProps,
  Textarea,
} from '@soluto-private/mx-asurion-ui-react';

const TextAreaContainer = styled.div`
  flex-grow: 1;
  padding-top: 1em;
`;

export type TextAreaProps = Pick<AUITextAreaProps, 'label' | 'value'> & {
  'data-testid'?: string;
  onChange: (value: string) => void;
};

export const TextArea = ({
  'data-testid': dataTestId,
  label,
  onChange,
  value,
}: TextAreaProps) => (
  <TextAreaContainer>
    <Textarea
      className="fs-mask"
      data-testid={dataTestId}
      label={label}
      maxCharCount={500}
      onChange={(e) => onChange(e.target.value)}
      resize={false}
      value={value}
    />
  </TextAreaContainer>
);
